// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"ShoppingCartEmpty_paginationPageDropdownWrap__AA-aP","pageContainer":"ShoppingCartEmpty_pageContainer__C0zRJ"};